import { defineMessages } from 'react-intl';

export const messages: {
	filterIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterIconLabel: {
		id: 'filter',
		defaultMessage: 'Filter icon',
		description: 'Filter icon label text',
	},
});
